import React from "react";
import { useLanguageContext } from "../../../contexts/LanguageContext";
import "./Footer.css";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  const { content } = useLanguageContext();
  const routes: Record<string, string> = {
    Blog: "/blog",
    Docs: "/docs"
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-brand">
            <div className="logo">
            <Link to="/home">
              <img src="assets/img/hero/logo.svg" height="50" alt="logo" />
            </Link>
          </div>
            <p className="footer-description">
              {content.footer.description}
            </p>
            <a className="footer-terms" href="/privacy">
              Privacy Policy
            </a>
            {" · "}
            <a className="footer-terms" href="/terms">
              Terms & Conditions
            </a>
          </div>

          {/* Links Sections */}
          <div className="footer-links">
            <div className="footer-section">
              <h4>{content.footer.links.company.title}</h4>
              <ul>
                {content.footer.links.company.items.map(
                  (item: string, index: number) => (
                    <li key={index}>
                      <a href={`#${item.toLowerCase()}`}>{item}</a>
                    </li>
                  ),
                )}
              </ul>
            </div>

            <div className="footer-section">
              <h4>{content.footer.links.product.title}</h4>
              <ul>
                {content.footer.links.product.items.map(
                  (item: string, index: number) => (
                    <li key={index}>
                      <a href={`#${item.toLowerCase()}`}>{item}</a>
                    </li>
                  ),
                )}
              </ul>
            </div>

            <div className="footer-section">
              <h4>{content.footer.links.support.title}</h4>
              <ul>
                {content.footer.links.support.items.map(
                  (item: string, index: number) => {
                    const route = routes[item];
                    const isFaq = item.toLowerCase().indexOf("faq") !== -1;

                    return (
                      <li key={index}>
                        {route ? (
                          <a href={`https://${item.toLowerCase()}.makemyday.tips`}>{item}</a>
                        ) : (isFaq ? (
                            <a href="https://docs.makemyday.tips/docs/faq">{item}</a>
                            ) : (
                              <a href={`#${item.toLowerCase()}`}>{item}</a>
                        ))}
                      </li>
                    );
                  },
                )}
              </ul>
            </div>
          </div>

          {/* Social Section */}
          <div className="footer-social">
            <h4>{content.footer.social.title}</h4>
            <p>{content.footer.social.description}</p>
            <div className="social-icons">
              <a
                href="https://x.com/MakeMyDayAI"
                className="social-icon"
                aria-label="Twitter"
                target="_blank"
              >
                <img src="assets/icons/x.svg"></img>
              </a>
              <a
                href="https://t.me/i_make_your_day_bot"
                className="social-icon"
                aria-label="Telegram"
                target="_blank"
              >
                <img src="assets/icons/telegram.svg" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61584051100792"
                className="social-icon"
                aria-label="Facebook"
                target="_blank"
              >
                <img src="assets/icons/facebook.svg" />
              </a>
              <a
                href="https://www.instagram.com/makemydayAI"
                className="social-icon"
                aria-label="Instagram"
                target="_blank"
              >
                <img src="assets/icons/instagram.svg" />
              </a>
              <a
                href="https://www.tiktok.com/@makemydayAI"
                className="social-icon"
                aria-label="Tiktok"
                target="_blank"
              >
                <img src="assets/icons/tiktok.svg" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <p>{content.footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
